import * as React from 'react';
import { WrappedComponentProps as InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { StateType } from '../../reducers';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { ToolTip } from '../ToolTip';

import './PerformanceStats.scss';
import { getTutorialUrl } from '../../shared/helpers/alphaMetricsTutorialLinks';

export interface PerformanceStatsProps {
  path: string[];
}

interface PerformanceStatsStateProps {
  stats: any;
}

const getFormattedFieldValue = (value: string, type: string) => {
  const symbol = type === 'percent' ? ' %' : type === 'permyriad' ? ' ‱' : '';
  return `${value}${symbol}`;
};

function PerformanceStats({ stats }: PerformanceStatsProps & PerformanceStatsStateProps & InjectedIntlProps) {
  if (!stats) {
    return null;
  }

  return (
    <div className="peformance-stats-container">
      <div className="peformance-stats-aggregate">
        <div className="peformance-stats-aggregate-title">
          <FormattedMessageHelper id="alphaSummary.aggregateData" />
        </div>
      </div>
      {stats.map((field: any) => (
        <div key={`performance-stats-${field.get('id')}`} className="peformance-stats-info">
          <div className="peformance-stats-info__title">
            <FormattedMessageHelper id={field.get('title')} />
            <ToolTip
              label={`tooltip.${field.get('id')}.label`}
              tooltipInfo={`tooltip.${field.get('id')}.content`}
              url={getTutorialUrl(field.get('id'))}
            />
          </div>
          <div className="peformance-stats-info__value">
            <div className="peformance-stats-info__value--data">{getFormattedFieldValue(field.get('value'), field.get('type'))}</div>
            <div className="peformance-stats-info__comparison">
              <div className={`peformance-stats-info__comparison--${field.get('change')} peformance-stats-info__comparison--icon`} />
              <div className={`peformance-stats-info__comparison--${field.get('change')}`}>{field.get('difference')}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state: StateType, props: PerformanceStatsProps): PerformanceStatsStateProps => ({
  stats: state.getIn(props.path),
});

export default connect<PerformanceStatsStateProps, any, any, StateType>(mapStateToProps)(injectIntl(PerformanceStats));
